import ReactQuill from "react-quill";

function QuillViewer(props) {


  let value = props.value;

  value = value.replaceAll('img src', 'img style="width: 100%" src')
  return (

    <div dangerouslySetInnerHTML={{
      __html: value,
    }}
    ></div>
  );
}

// function QuillViewer(props) {


//   return (

//     <ReactQuill
//       key={props.value}
//       value={props.value}
//       readOnly={true}
//       theme={"bubble"}
//       {...props}
//     />
//   );
// }

export default QuillViewer;
